import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { PathPreviewHeader } from '../PathPreviewHeader/PathPreviewHeader';
import { PathPreviewRenderProps } from '../../types';

const StyledPathPreview = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  // gap: theme.spacing(4),
}));

const StyledHeader = styled('header')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(3),
  flexWrap: 'wrap',
}));

export type PathPreviewShellProps = PathPreviewRenderProps & {
  action?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
};

export const PathPreviewShell = ({
  path,
  secondary,
  action,
  children,
  footer,
}: PathPreviewShellProps) => (
  <StyledPathPreview>
    <StyledHeader>
      <PathPreviewHeader path={path} secondary={secondary} />
      {action}
    </StyledHeader>
    {children}
    {footer}
  </StyledPathPreview>
);
